"use client";

import React, { useState } from "react";
import Button from "../button";
import PlayBtn from "../svg/play";
import PlayBtnYellow from "../svg/play-yellow";

interface VideoPlayerProps {
    videoId: string; // ID видео из YouTube
    poster: string; // Ссылка на постер
}

const VideoPlayer: React.FC<VideoPlayerProps> = ({ videoId, poster }) => {
    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlay = () => {
        setIsPlaying(true);
    };

    return (
        <div className="relative w-full mx-auto aspect-video rounded-[40px] overflow-hidden shadow-lg max-[576px]:rounded-[16px]">
            {!isPlaying ? (
                <div className="relative w-full h-full bg-gray-900">
                    <img
                        src={poster}
                        alt="Video Poster"
                        className="w-full h-full object-cover rounded-[40px] max-[576px]:rounded-[16px]"
                    />
                    <div
                        onClick={handlePlay}
                        className="absolute inset-0 flex items-center justify-center bg-black/50 hover:bg-black/30 transition-colors"
                    >
                    <Button icon={<PlayBtn />} hoverIcon={<PlayBtnYellow />} type="secondary" isvideoBtn="yes"/>
                    </div>
                </div>
            ) : (
                <iframe
                    src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                    title="YouTube Video Player"
                    className="w-full h-full rounded-2xl"
                    frameBorder="0"
                    allow="autoplay; encrypted-media; picture-in-picture"
                    allowFullScreen
                ></iframe>
            )}
        </div>
    );
};

export default VideoPlayer;
